import {Injectable} from '@angular/core';
import {HttpClient, HttpParams} from "@angular/common/http";
import 'rxjs/add/operator/toPromise';
import config from '../../../config';
import {Service} from "../../../classes/service";
import {ServiceLog} from "../../../classes/serviceLog";
import {kanLoadingService} from "./loading";

@Injectable()
export class kanServicesService {
    constructor(private http: HttpClient,
                private loadingService: kanLoadingService) {
    }

    public getServices(filter: any = {}): Promise<Service[]> {
        return new Promise((resolve, reject) => {
            filter.include = filter.include || [];
            filter.include.push('contract');
            let params = new HttpParams().set('filter', JSON.stringify(filter));
            this.http.get(`${config.apiRootUrl}/api/services`, {params: params})
                .toPromise()
                .then((response: any) => {
                    resolve(response.sort((item1, item2) => {
                        return item1.service < item2.service ? -1 : item1.service > item2.service ? 1 : 0;
                    }) as Service[]);
                })
                .catch((error: any) => {
                    reject(error);
                });
        });
    }

    public addService(service: Service): Promise<Service> {
        this.loadingService.show();
        return new Promise((resolve, reject) => {
            this.http.post(`${config.apiRootUrl}/api/services`, service)
                .toPromise()
                .then((response: any) => {
                    this.loadingService.hide();
                    resolve(response as Service);
                })
                .catch((error: any) => {
                    this.loadingService.hide();
                    reject(error);
                });
        });
    }

    public updateService(service: Service): Promise<Service> {
        this.loadingService.show();
        return new Promise((resolve, reject) => {
            this.http.patch(`${config.apiRootUrl}/api/services`, service)
                .toPromise()
                .then((response: any) => {
                    this.loadingService.hide();
                    resolve(response as Service);
                })
                .catch((error: any) => {
                    this.loadingService.hide();
                    reject(error);
                });
        });
    }

    public countLogs(where: any = {}): Promise<number> {
        return new Promise((resolve, reject) => {
            let params = new HttpParams().set('where', JSON.stringify(where));
            this.http.get(`${config.apiRootUrl}/api/serviceLogs/count`, {params: params})
                .toPromise()
                .then((response: any) => {
                    resolve(response.count as number);
                })
                .catch((error: any) => {
                    reject(error);
                });
        });
    }

    public getLogs(filter: any = {}): Promise<ServiceLog[]> {
        return new Promise((resolve, reject) => {
            let params = new HttpParams().set('filter', JSON.stringify(filter));
            this.http.get(`${config.apiRootUrl}/api/serviceLogs`, {params: params})
                .toPromise()
                .then((response: any) => {
                    let services = response.map((service) => {
                        service.start = service.start ? new Date(service.start) : null;
                        service.end = service.end ? new Date(service.end) : null;
                        return service;
                    });
                    resolve(services as ServiceLog[]);
                })
                .catch((error: any) => {
                    reject(error);
                });
        });
    }

    public getUserServicesLog(userId): Promise<ServiceLog[]> {
        return new Promise((resolve, reject) => {
            let filter = {
                where: {
                    userId: userId
                },
                order: 'start DESC',
                include: ['service', 'dog']
            };
            let params = new HttpParams().set('filter', JSON.stringify(filter));
            this.http.get(`${config.apiRootUrl}/api/serviceLogs`, {params: params})
                .toPromise()
                .then((response: any) => {
                    let services = response.map((service) => {
                        service.start = service.start ? new Date(service.start) : null;
                        service.end = service.end ? new Date(service.end) : null;
                        return service;
                    });
                    resolve(services as ServiceLog[]);
                })
                .catch((error: any) => {
                    reject(error);
                });
        });
    }

    public getDogServicesLog(dogId): Promise<ServiceLog[]> {
        return new Promise((resolve, reject) => {
            let filter = {
                where: {
                    dogId: dogId
                },
                order: 'start DESC',
                include: ['service']
            };
            let params = new HttpParams().set('filter', JSON.stringify(filter));
            this.http.get(`${config.apiRootUrl}/api/serviceLogs`, {params: params})
                .toPromise()
                .then((response: any) => {
                    let services = response.map((service) => {
                        service.start = service.start ? new Date(service.start) : null;
                        service.end = service.end ? new Date(service.end) : null;
                        return service;
                    });
                    resolve(services as ServiceLog[]);
                })
                .catch((error: any) => {
                    reject(error);
                });
        });
    }

    public addServiceLog(serviceLog: ServiceLog): Promise<ServiceLog> {
        this.loadingService.show();
        return new Promise((resolve, reject) => {
            this.http.post(`${config.apiRootUrl}/api/serviceLogs`, serviceLog)
                .toPromise()
                .then((response: any) => {
                    this.loadingService.hide();
                    resolve(response as ServiceLog);
                })
                .catch((error: any) => {
                    this.loadingService.hide();
                    reject(error);
                });
        });
    }

    public updateServiceLog(serviceLog: ServiceLog): Promise<ServiceLog> {
        this.loadingService.show();
        return new Promise((resolve, reject) => {
            this.http.patch(`${config.apiRootUrl}/api/serviceLogs/${serviceLog.id}`, serviceLog)
                .toPromise()
                .then((response: any) => {
                    this.loadingService.hide();
                    resolve(response as ServiceLog);
                })
                .catch((error: any) => {
                    this.loadingService.hide();
                    reject(error);
                });
        });
    }

    public removeService(serviceLog: ServiceLog): Promise<any> {
        this.loadingService.show();
        return new Promise((resolve, reject) => {
            this.http.delete(`${config.apiRootUrl}/api/serviceLogs/${serviceLog.id}`)
                .toPromise()
                .then((response: any) => {
                    this.loadingService.hide();
                    resolve();
                })
                .catch((error: any) => {
                    this.loadingService.hide();
                    reject(error);
                });
        });
    }
}



// WEBPACK FOOTER //
// ./src/modules/services/services/services.ts